module.exports = __webpack_public_path__ + "img/treasure.1e19dadd.png";